import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  index = 'NotFound',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/:pathMatch(.*)*',
    component: () => import('@/modules/not-found/layout/LayoutPage.vue'),
    children: [
      {
        path: '',
        name: MODULE_ROUTE.index,
        component: () => import('@/modules/not-found/pages/NotFound.vue'),
        meta: {
          i18nAlias: 'not-found',
        },
      },
    ],
  },
];
